// src/pages/DashboardPage/DashboardPage.jsx
import React from "react";
import ExcursionsTab from "features/excursions/ExcursionsTab";
import ChalesTab from "features/chales/ChalesTab";
import { useUser } from "hooks/useUser";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";

function DashboardPage() {
  const { role, canViewExcursions, canViewChales } = useUser();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchTerm(inputValue);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue]);

  const defaultTab = canViewExcursions
    ? "excursions"
    : canViewChales
      ? "chales"
      : "chales";

  return (
    <div className="container mx-auto" userRole={role}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Buscar por telefone..."
            className="border p-2 rounded w-64 text-black dark:text-white dark:bg-gray-800 border-gray-300 dark:border-gray-600"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      </div>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList>
          {canViewExcursions && (
            <TabsTrigger value="excursions">Excursões</TabsTrigger>
          )}

          {canViewChales && <TabsTrigger value="chales">Chalés</TabsTrigger>}
        </TabsList>

        {canViewExcursions && (
          <TabsContent value="excursions" className="mt-6">
            <ExcursionsTab userRole={role} searchTerm={searchTerm} />
          </TabsContent>
        )}

        {canViewChales && (
          <TabsContent value="chales" className="mt-6">
            <ChalesTab userRole={role} searchTerm={searchTerm} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}

export default DashboardPage;
